/**
 * External Dependencies
 */
import React from 'react';
import FontAwesomeIcon from 'react-fontawesome';
import classNames from 'classnames';
import { get } from 'lodash';

import { IconContext } from 'react-icons';
import * as fa from 'react-icons/fa';
import * as fi from 'react-icons/fi';
import * as md from 'react-icons/md';

const icons = {
    fa,
    fi,
    md
};

/**
 * Internal Dependencies
 */

const Icon = ({ type, name, className, ...rest }) => {
    const IconComponent = get(icons, [type, name], null);
    return IconComponent ? (
        <IconContext.Provider value={{ style: { verticalAlign: 'middle' }, className: classNames('icon', className) }}>
            <IconComponent {...rest} />
        </IconContext.Provider>
    ) : null;
};

Icon.defaultProps = {
    type: 'fi',
    name: 'cantfindme',
};

export default Icon;
